"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineHelpDocumentId = void 0;
const react_1 = __importDefault(require("react"));
const ReactDOM = __importStar(require("react-dom"));
const config_1 = __importDefault(require("../config"));
const mobx_1 = require("mobx");
const lib_1 = require("@brandfree-front/lib");
const StoresUtil_1 = require("../util/StoresUtil");
var OnlineHelpDocumentId;
(function (OnlineHelpDocumentId) {
    OnlineHelpDocumentId["PRIVACY_NOTICE"] = "645";
    OnlineHelpDocumentId["CORRECT_PERSONAL_DATA"] = "658";
    OnlineHelpDocumentId["FORGET_PERSONAL_DATA"] = "659";
    OnlineHelpDocumentId["OBJECTION"] = "660";
    OnlineHelpDocumentId["RESTRICT_DATA_PROCESSING"] = "661";
    OnlineHelpDocumentId["TRANSFER_PERSONAL_DATA"] = "662";
    OnlineHelpDocumentId["VIEW_PERSONAL_DATA"] = "657";
})(OnlineHelpDocumentId || (exports.OnlineHelpDocumentId = OnlineHelpDocumentId = {}));
let OnlineHelp = class OnlineHelp extends react_1.default.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "locationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    componentDidMount() {
        (0, mobx_1.reaction)(() => this.locationStore.currentLanguage, () => window.location.reload());
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `${config_1.default.teliaWWWUrl}/abi/js/web-main.min.js`;
        document.head.appendChild(script);
        const sheet = document.createElement('link');
        sheet.rel = 'stylesheet';
        sheet.href = `${config_1.default.teliaWWWUrl}/abi/css/web.css`;
        sheet.type = 'text/css';
        document.head.appendChild(sheet);
        script.onload = () => {
            window.telia = {};
            window.onlineHelp.init(ReactDOM.findDOMNode(this), {
                sequenceId: this.props.documentId,
                preferredLanguage: this.locationStore.currentLanguage,
                iconPrefix: '/svg/icons.svg#',
                baseUrl: config_1.default.teliaWWWUrl
            });
        };
    }
    render() {
        return (react_1.default.createElement(lib_1.Grid, { align: ['center-xs'] },
            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'md-10', 'lg-8'] },
                react_1.default.createElement(lib_1.Text, null, this.props.children))));
    }
};
OnlineHelp = __decorate([
    StoresUtil_1.injectStores
], OnlineHelp);
exports.default = OnlineHelp;
